import { NoteInfoInputExtended } from './types'
import { ObjectiveTemplateInput, UserInfo } from '../../../types'

export const transformTargetTemplateBeforeSave = (
  user: UserInfo,
  target: ObjectiveTemplateInput,
  comments: NoteInfoInputExtended[],
  commentFromInput: NoteInfoInputExtended | undefined,
): ObjectiveTemplateInput => {
  const transformed = { ...target, lastEditedDate: undefined, objectiveNotes: [] } as ObjectiveTemplateInput

  transformed.objectiveTitle = transformed.objectiveTitle.trim()

  transformed.objectiveKeyResults = transformed.objectiveKeyResults.map((okr, index) => {
    return { ...okr, text: okr.text.trim(), displayOrder: index + 1 }
  })

  if (!!comments && !!comments.length) {
    transformed.objectiveNotes = comments.map((comment) => {
      if (!comment.isNewComment) {
        return { ...comment }
      }
      return { author: comment.author, date: comment.date, text: comment.text }
    })
  }

  if (!!commentFromInput && !!commentFromInput.text.trim()) {
    transformed.objectiveNotes.push({ author: commentFromInput.author, date: commentFromInput.date, text: commentFromInput.text })
  }

  transformed.creator = target.id
    ? { id: target.creator.id, firstName: target.creator.firstName, lastName: target.creator.lastName, avatarUrl: target.creator.avatarUrl }
    : { id: user.employeeId, firstName: user.firstName, lastName: user.lastName, avatarUrl: user.avatarUrl }
  transformed.lastModifier = { id: user.employeeId, firstName: user.firstName, lastName: user.lastName, avatarUrl: user.avatarUrl }

  return transformed
}
